import React, { PropTypes } from 'react';
import PageComponent from 'components/Page/_PageComponent';

const Page = ({ data }) => {
  return (
    <div>
      {data.map((component, i) =>
        <PageComponent key={i} {...component} />
      )}
    </div>
    );
};

Page.propTypes = {
  data: PropTypes.array
};

export default Page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/Page.js
 **/